import './App.css';
import Routers from "./router";
import 'bootstrap/dist/css/bootstrap.min.css'
import React from "react";
import { Helmet } from 'react-helmet';

function App() {
  // Scripts are now loaded via index.html with proper defer/async attributes
  // No need to dynamically append them here


  return (
    <>
      <div className="App">
        <Helmet>
          <title>Infocliq - AI-Powered Digital Products for Startups</title>
          <meta name="description" content="Infocliq helps startups build world-class digital products with AI-powered web, mobile, and ecommerce solutions. Expert software development and intelligent automation." />
          <meta name="keywords" content="AI software development, startup solutions, web apps, mobile apps, AI chatbots, business automation, data analytics, digital products" />
          <meta name="author" content="Infocliq" />
        </Helmet>
        <Routers />
      </div>
    </>
  );
}

export default App;
